export default {
  data() {
    return {
      CFCDForm: {
        xycfcdqk: "",
        xycfmj: "",
        xybgcdqk: "",
        xybgmj: "",
        sfyydxq: "",
        ydxqlx: "",
        cdlx: "",
        cfcdmj: "",
        bgscdmj: ""
      },
      CFCDRules: {
        xycfmj: [
          {
            required: true,
            message: "请选择现有厂房面积",
            trigger: ["blur", "change"]
          }
        ],
        xybgmj: [
          {
            required: true,
            message: "请选择现有办公面积",
            trigger: ["blur", "change"]
          }
        ],
        cdlx: [
          {
            required: true,
            message: "请选择场地类型",
            trigger: ["blur", "change"]
          }
        ],
        ydxqlx: [
          {
            required: true,
            message: "请选择用地需求类型",
            trigger: ["blur", "change"]
          }
        ],
        bgscdmj: [
          {
            required: true,
            message: "请选择办公室场地面积",
            trigger: ["blur", "change"]
          }
        ],
        cfcdmj: [
          {
            required: true,
            message: "请选择厂房场地面积",
            trigger: ["blur", "change"]
          }
        ]
      },
      xycfmjList: [
        { name: "500㎡以下（含500）", code: "1" },
        { name: "500-1000㎡（含1000）", code: "2" },
        { name: "1000-2000㎡（含2000）", code: "3" },
        { name: "2000-5000㎡（含5000）", code: "4" },
        { name: "5000-10000㎡（含10000）", code: "5" },
        { name: "10000㎡以上", code: "6" }
      ],
      xybgmjList: [
        { name: "300㎡以下（含300）", code: "1" },
        { name: "300-500㎡（含500）", code: "2" },
        { name: "500-1000㎡（含1000）", code: "3" },
        { name: "1000-2000㎡（含2000）", code: "4" },
        { name: "2000-5000㎡（含50000）", code: "5" },
        { name: "5000㎡以上", code: "6" }
      ],
      ydxqlxList: [
        { name: "自购", code: "1" },
        { name: "租用", code: "2" }
      ],
      bgscdmjList: [
        { name: "300㎡以下（含300）", code: "1" },
        { name: "300-500㎡（含500）", code: "2" },
        { name: "500-1000㎡（含1000）", code: "3" },
        { name: "1000-2000㎡（含2000）", code: "4" },
        { name: "2000-5000㎡（含50000）", code: "5" },
        { name: "5000㎡以上", code: "6" }
      ],
      cfcdmjList: [
        { name: "500㎡以下（含500）", code: "1" },
        { name: "500-1000㎡（含1000）", code: "2" },
        { name: "1000-2000㎡（含2000）", code: "3" },
        { name: "2000-5000㎡（含5000）", code: "4" },
        { name: "5000-10000㎡（含10000）", code: "5" },
        { name: "10000㎡以上", code: "6" }
      ]
    };
  },
  methods: {
    xycfcdqkChange() {
      this.CFCDForm.xycfmj = "";
      this.$refs["CFCDForm"].clearValidate();
    },
    xybgcdqkChange() {
      this.CFCDForm.xybgmj = "";
      this.$refs["CFCDForm"].clearValidate();
    },
    sfyydxqChange() {
      this.CFCDForm.ydxqlx = "";
      this.CFCDForm.cdlx = "";
      this.$refs["CFCDForm"].clearValidate();
    },
    cdlxChange() {
      this.CFCDForm.bgscdmj = "";
      this.CFCDForm.cfcdmj = "";
      this.$refs["CFCDForm"].clearValidate();
    }
  }
};
